import { FC } from "react";

import { PillBanner } from "./PillBanner";

import { serverEndSession } from "api/api-server-actions";
import { t } from "i18n/i18n";
import { IconText } from "mds/components/IconText";
import { PillButton } from "mds/components/PillButton";
import { InPersonIcon } from "mds/icons";
import { useAppSelector } from "store/index";
import { selectActiveClassSessionId, selectCurrentClassUserId } from "store/selectors";
import { useClassActions } from "utils/class-utils";
import { useFollow } from "utils/hooks/use-follow";

interface JoinInPersonClassButtonProps {
  isInstructor?: boolean;
}

export const JoinInPersonClassButton: FC<JoinInPersonClassButtonProps> = ({
  isInstructor = false,
}) => {
  const classSessionId = useAppSelector(selectActiveClassSessionId);
  const currentClassUserId = useAppSelector(selectCurrentClassUserId);
  const { joinClass } = useClassActions();
  const { maybeStartFollowing } = useFollow();

  const onJoinClass = () => {
    joinClass();
    maybeStartFollowing();
  };

  const endInPersonSession = () => {
    if (!classSessionId) return;
    serverEndSession(classSessionId);
  };

  if (!currentClassUserId) {
    return null;
  }

  return (
    <PillBanner
      buttonChildren={
        isInstructor ? (
          <>
            <PillButton
              eventName="Enter class"
              kind="blue"
              size="s"
              title={t("footer.join_session")}
              onClick={onJoinClass}
            >
              {t("footer.join_session")}
            </PillButton>
            <PillButton
              className="border border-red-tint-70 bg-red-tint-99"
              eventName="End Class for All"
              size="s"
              title={t("av.stop_virtual_class_short")}
              onClick={endInPersonSession}
            >
              {t("av.stop_virtual_class_short")}
            </PillButton>
          </>
        ) : (
          <PillButton
            eventName="Enter class"
            kind="blue"
            size="s"
            title={t("footer.join_session")}
            onClick={onJoinClass}
          >
            {t("footer.join_session")}
          </PillButton>
        )
      }
      kind="blue"
      textChildren={
        <IconText
          iconStart={<InPersonIcon className="text-blue-shade-40" />}
          text={t("footer.in_person_class_in_session")}
          truncateText
        />
      }
    />
  );
};
